import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";
import BaseService from "./base.service";

export default class TimesheetService extends BaseService {
  fetchTimesheets = ({ page = 1, size = 10, ...data }) => {
    return this.axios.get(API_ENDPOINTS.LIST_TIMESHEET, {
      params: {
        page,
        size,
        ...data,
      },
    });
  };

  saveTimesheet = (entries) => {
    return this.axios.post(API_ENDPOINTS.SAVE_TIMESHEET, { entries });
  };
}
